import { createStore } from 'vuex'

export default createStore({
  state: {
    showPopup: false,
    showPopup360: false,
    popupType: null,
    selected: null,
    selectedIndex: null,
    selectedRoute: "route-1",
    shipArea: 2,
    shipHover: null,
    shipAreas: [
      {
        name: "Captain's Cabin", map: "./images/captains_cabin.jpg", objs: [
          { name: "Astrolabe", id: 'captain01', r: 314, v: -2.25, z: 7 },
          { name: "Traverse Board", id: 'captain02', r: 106, v: -1.5, z: 10 },
          { name: "Sword", id: 'captain03', r: 56, v: 3, z: 10 },
          { name: "Harquebus", id: 'captain04', r: 50, v: 4.5, z: 4 },
          { name: "Replica Chart", id: 'captain05', r: 311, v: -6, z: 8 },
          { name: "Lanterns", id: 'captain06', r: 88, v: 5.5, z: 6 },
          { name: "Message Sticks", id: 'captain07', r: 294, v: -4, z: 10 },
          { name: "Ceremonial Spear", id: 'captain08', r: 300, v: -2.5, z: 10 },
          { name: "Captain’s Bed", id: 'captain09', r: 20, v: -5, z: 7 },
          { name: "Merchant’s Bed", id: 'captain10', r: 140, v: -6, z: 4 },
          { type: "door", name: "Main Cabin", zone: 1, rot: 200, r: 354, v: -3, z: 6, sRot: -90 }]
      },
      {
        name: "Main Cabin", map: "./images/main_cabin.jpg", objs: [
          { name: "Bilge Pumps", id: 'cabin01', r: 82, v: -2, z: 6 },
          { name: "Spices", id: 'cabin02', r: 276, v: -6, z: 6 },
          { name: "Whipstaff", id: 'cabin03', r: 93.5, v: 0.5, z: 12 },
          { name: "Sleeping Quarters", id: 'cabin04', r: 44, v: -5, z: 6 },
          { name: "Leadline", id: 'cabin05', r: 122, v: -1.5, z: 10 },
          { name: "Wooden Box", id: 'cabin06', r: 54, v: -2.5, z: 12 },
          { type: "door", name: "Main Deck", zone: 2, rot: 200, r: 317, v: -2.5, z: 8 },
          { type: "door", name: "Main Deck", zone: 2, rot: 160, r: 242, v: -3, z: 8 },
          { type: "door", name: "Captain's Cabin", zone: 0, rot: 1, r: 72, v: -0.25, z: 10 },
          { type: "door", name: "Tiller Flat", zone: 4, rot: 210, r: 110, v: -2.5, z: 6, sRot: 180 }]
      },
      {
        name: "Main Deck", map: "./images/main_deck.jpg", objs: [
          { name: "Falcon Gun", id: 'deck01', r: 115, v: -1, z: 12 },
          { name: "Windlass", id: 'deck02', r: 288, v: -3, z: 8 },
          { name: "Anchor", id: 'deck03', r: 282, v: 2, z: 8 },
          { name: "Mast", id: 'deck04', r: 87.5, v: 5, z: 12 },
          { name: "Cleats", id: 'deck05', r: 38, v: -1.5, z: 10 },
          { name: "Cargo Hatch", id: 'deck06', r: 82, v: -2, z: 8 },
          { name: "Main Deck", id: 'deck07', r: 126, v: -3.5, z: 8 },
          { name: "Ratlines", id: 'deck08', r: 300, v: 4.5, z: 10 },
          { name: "Sails", id: 'deck09', r: 262, v: 3, z: 10 },
          { type: "door", name: "Main Cabin", zone: 1, rot: 20, r: 100, v: 1, z: 14 },
          { type: "door", name: "Main Cabin", zone: 1, rot: -20, r: 77, v: 1, z: 14 },
          { type: "door", name: "Forecastle", zone: 5, rot: 1, r: 300, v: -1.5, z: 10 },
          { type: "door", name: "Cargo Hold", zone: 3, rot: 180, r: 298, v: -4.5, z: 4, sRot: 180 }]
      },
      {
        name: "Cargo Hold", map: "./images/cargo_hold.jpg", objs: [
          { name: "Spare Sails", id: 'cargo01', r: 0, v: 3, z: 8 },
          { name: "Spare Rigging", id: 'cargo02', r: 110, v: 0, z: 14 },
          { name: "Ballast Bricks", id: 'cargo03', r: 286, v: -4.5, z: 6 },
          { name: "Ramrods", id: 'cargo04', r: 318, v: -2, z: 10 },
          { name: "Rationed Food", id: 'cargo05', r: 66, v: -2.5, z: 8 },
          { name: "Shots", id: 'cargo06', r: 328, v: -2.5, z: 8 },
          { name: "Cow Horn", id: 'cargo07', r: 236, v: 0.25, z: 12 },
          { name: "Cargo Barrels", id: 'cargo08', r: 208, v: -2.25, z: 8 },
          { name: "Beardman Jugs", id: 'cargo09', r: 248, v: -1, z: 10 },
          { name: "Cargo Hatch", id: 'deck06', r: 290, v: 5, z: 4 },
          { name: "Lanterns", id: 'captain06', r: 148.5, v: 2.75, z: 12 },
          { type: "door", name: "Main Deck", zone: 2, rot: 1, r: 88, v: 1, z: 7 },
          { type: "door", name: "Tiller Flat", zone: 4, rot: 210, r: 276, v: -1, z: 10 }]
      },
      {
        name: "Tiller Flat", map: "./images/tiller_flat.jpg", objs: [
          { name: "Medical Kit", id: 'tiller01', r: 322, v: -2.5, z: 10 },
          { name: "Medical Tools", id: 'tiller02', r: 304, v: -1.5, z: 12 },
          { name: "Tiller", id: 'tiller03', r: 278, v: 2, z: 6 },
          { name: "Tiller Stoppers", id: 'tiller04', r: 195, v: 4, z: 8 },
          { name: "Tiller Stoppers", id: 'tiller04', r: 328, v: 3.5, z: 8 },
          { name: "Constable", id: 'tiller05', r: 260, v: -5, z: 8 },
          { name: "Lanterns", id: 'captain06', r: 150, v: 3, z: 8 },
          { name: "Gun Ports", id: 'front02', r: 58, v: -0.25, z: 10 },
          { type: "door", name: "Main Cabin", zone: 1, rot: 160, r: 218, v: 1, z: 7 },
          { type: "door", name: "Cargo Hold", zone: 3, rot: 1, r: 278, v: -2, z: 8 }]
      },
      {
        name: "Forecastle", map: "./images/forecastle.jpg", objs: [
          { name: "Waters Barrels", id: 'front01', r: 140, v: -4, z: 4 },
          { name: "Gun Ports", id: 'front02', r: 192, v: -2.25, z: 10 },
          { name: "Cooking", id: 'front03', r: 134, v: 0, z: 6 },
          { name: "Anchor", id: 'deck03', r: 295, v: -0.5, z: 8 },
          { type: "door", name: "Main Deck", zone: 2, rot: 1, r: 325, v: -0.5, z: 8 }]
      }
    ],
    items360: {
      deck01: {
        title: "Falcon Gun",
        description: "This is called a falcon gun. It was used to defend against attackers of the Duyfken.",
        icon: "popup-still falcon-gun"
      },
      deck02: {
        title: "Windlass",
        description: "This is called a windlass. The crew turn it to help lift and lower the extremely heavy anchor.",
        icon: "popup-still windlass"
      },
      deck03: {
        title: "Anchor",
        description: "The anchor is attached to a cable. It is lowered overboard and rests on the seafloor to stop the ship floating away.",
        icon: "popup-still anchor"
      },
      deck04: {
        title: "Mast",
        description: "This pole of wood is the main mast of the Duyfken. It’s the tallest mast on the ship and carries two large sails.",
        icon: "popup-still mast"
      },
      deck05: {
        title: "Cleats",
        description: "This object is called a cleat. It holds a rope called a mooring line that is used to tie the ship to a wharf.",
        icon: "popup-still cleats"
      },
      deck06: {
        title: "Cargo Hatch",
        description: "This hatch is a type of door used to access lower parts of the ship. It's mainly used for loading cargo into the cargo hold, below the main deck.",
        icon: "popup-still cargo-hatch"
      },
      deck07: {
        title: "Main Deck",
        description: "The crew also slept on the main deck when the weather was nice. There was no light pollution, so the stars in the sky would have looked amazing!",
        icon: "popup-still main-deck"
      },
      deck08: {
        title: "Ratlines",
        description: "Ratlines are rope ladders that the crew climb up to reach the high parts of the mast and sails.",
        icon: "popup-still ratlines"
      },
      deck09: {
        title: "Sails",
        description: "The Duyfken's six sails are the engine of the ship. The sails catch the wind and move the ship forward. The average speed is five knots, about the speed of a quick walk.",
        icon: "popup-still sails"
      },
      cabin01: {
        title: "Bilge Pumps",
        description: "These two wooden handles were used to stop the ship from sinking! They would be pulled up and down to pump sea water from inside the ship, back into the ocean.",
        icon: "popup-still bilge-pumps"
      },
      cabin02: {
        title: "Spices",
        description: "The Dutch East India Company (VOC) traded valuable spices like pepper, star anise, cinnamon, cloves and nutmeg. Sacks of spices were stored below in the cargo hold where they were safe and dry.",
        icon: "popup-still spices"
      },
      cabin03: {
        title: "Whipstaff",
        description: "The whipstaff is a wooden handle used to change the direction of the ship by moving it side to side. It is connected to the tiller, a part of the steering system below the deck.",
        icon: "popup-still whipstaff"
      },
      cabin04: {
        title: "Sleeping Quarters",
        description: "This is where the 20 crewmen slept. It’s cramped, but there were always a few people working on the deck, so not everyone had to fit at the same time. There was shelter from the sun and rain.",
        icon: "popup-still sleeping-quarters"
      },
      cabin05: {
        title: "Leadline",
        description: "This heavy piece of lead attached to a rope was thrown overboard to measure the depth of the water. This tool helped prevent the ship from getting stuck on the sea floor.",
        icon: "popup-still leadline"
      },
      cabin06: {
        title: "Wooden Box",
        description: "This box has the Dutch East India Company logo on it. The company is called the 'Vereenigde Oostindische Compagnie' in Dutch, or VOC for short.",
        icon: "popup-still wooden-box"
      },
      captain01: {
        title: "Astrolabe",
        description: "This device is called an astrolabe. It was used to calculate latitude by measuring the height of the sun in the sky at noon.",
        icon: "popup-still astrolabe"
      },
      captain02: {
        title: "Traverse Board",
        description: "This devise is called a traverse board. It was used to show how fast and in which direction the ship was sailing.",
        icon: "popup-still traverse-board"
      },
      captain03: {
        title: "Sword",
        description: "Only the captain had a sword. It was used in combat and ceremonies and was a symbol for a high-ranking status.",
        icon: "popup-still sword"
      },
      captain04: {
        title: "Harquebus",
        description: "A long gun that was fired from the shoulder. To fire it, the end of the barrel was rested in the fork of the stick hanging below the gun.",
        icon: "popup-still harquebus"
      },
      captain05: {
        title: "Replica Chart",
        description: "This is a copy of the Duyfken’s original map. The crew explored roughly 300 kilometres of Cape York Peninsula in Queensland.",
        icon: "popup-still replica-chart"
      },
      captain06: {
        title: "Lanterns",
        description: "Keeping candles in lanterns stopped them getting blown out by wind and prevented the ship from catching on fire.",
        icon: "popup-still lanterns"
      },
      captain07: {
        title: "Message Sticks",
        description: "Message sticks were peacefully exchanged with Wik elders when the landing at Cape York Peninsula was re-enacted by the replica Duyfken in 2000. This time the crew came ashore with permission.",
        icon: "popup-still message-sticks"
      },
      captain08: {
        title: "Ceremonial Spear",
        description: "Spears were placed in the ground by members of the local Wik community to symbolise peace when crew of the replica Duyfken came ashore in 2000.",
        icon: "popup-still ceremonial-spear"
      },
      captain09: {
        title: "Captain’s Bed",
        description: "This is where the captain of the Duyfken sleeps. It's the bed closest to the door so they also can watch the crew.",
        icon: "popup-still captains-bed"
      },
      captain10: {
        title: "Merchant’s Bed",
        description: "This is where the merchant slept. The merchant was a representative of the VOC who told the captain where to trade. Nowadays it's where the first-mate or second-in-command sleeps.",
        icon: "popup-still merchants-bed"
      },
      front01: {
        title: "Water Barrels",
        description: "Barrels like these were stored on the main deck, so the crew had easy access to water. The barrels could also collect fresh water on rainy days.",
        icon: "popup-still water-barrels"
      },
      front02: {
        title: "Gun Ports",
        description: "Falcon guns were aimed through these gun ports to defend the Duyfken.",
        icon: "popup-still gun-ports"
      },
      front03: {
        title: "Cooking",
        description: "On most days the crew ate salted meat. If they did get a hot meal, it would only be cooked on the main deck in calm weather to reduce the chance of a fire.",  
        icon: "popup-still cooking"
      },
      tiller01: {
        title: "Medical Kit",
        description: "This is what a ship’s medical kit might have looked like. Much like modern first-aid kits, it has crosses on the front of it.",
        icon: "popup-still medical-kit"
      },
      tiller02: {
        title: "Medical Tools",
        description: "These are the medical tools a ship’s doctor might have. Doctors also often had saws for cutting off body parts that were too badly hurt to fix.",
        icon: "popup-still medical-tools"
      },
      tiller03: {
        title: "Tiller",
        description: "The tiller is the large timber beam that's connected to the whipstaff in the main cabin, and to the rudder at the rear of the ship. These connected parts are used to steer the ship.",
        icon: "popup-still tiller"
      },
      tiller04: {
        title: "Tiller Stoppers",
        description: "These coiled ropes physically stop the tiller from being moved too far to one side or the other.",
        icon: "popup-still tiller-stoppers"
      },
      tiller05: {
        title: "Constable",
        description: "The Constable would be in this room to keep guard of the supplies stored in the cargo hold.",
        icon: "popup-still constable"
      },
      cargo01: {
        title: "Spare Sails",
        description: "The crew kept spare parts here in case anything was damaged. This is an extra sail that could be used if the original sail got torn or shot.",
        icon: "popup-still spare-sails"
      },
      cargo02: {
        title: "Spare Rigging",
        description: "The cargo hold is where the Duyfken's crew stored their spare parts. There are about 8 kilometres of extra rope here!",
        icon: "popup-still spare-rigging"
      },
      cargo03: {
        title: "Ballast Bricks",
        description: "These ballast bricks aren’t just a nice floor. They're heavy and important for keeping the ship weighed down, so it doesn’t tip over!",
        icon: "popup-still ballast-bricks"
      },
      cargo04: {
        title: "Ramrods",
        description: "Ramrods were poles used to load guns before bullets were invented. It pushed down cloth, gunpowder and ammunition into the barrel of the gun.",
        icon: "popup-still ramrods"
      },
      cargo05: {
        title: "Rationed Food",
        description: "All the food and drink was kept below deck here in the cargo hold. The crew got the same amount each day, so the ship didn’t run out on long voyages.",
        icon: "popup-still rationed-food"
      },
      cargo06: {
        title: "Shots",
        description: "These small cannonballs are called shots. They could be fired at enemy ships to damage their sails.",
        icon: "popup-still shots"
      },
      cargo07: {
        title: "Cow Horn",
        description: "Cow horn is strong, flexible and easy to obtain. It was often used as a substitute for lantern glass because it was much harder to break.",
        icon: "popup-still cow-horn"
      },
      cargo08: {
        title: "Cargo Barrels",
        description: "Barrels like these were used regularly on ships for hundreds of years. Barrels in the cargo hold usually stored wine and beer, and sometimes water.",
        icon: "popup-still cargo-barrels"
      },
      cargo09: {
        title: "Beardman Jugs",
        description: "These beardman jugs were used to store strong alcohol. They have a face with a beard carved into the neck of the jug.",
        icon: "popup-still beardman-jugs"
      }
    }
  },
  getters: {
    getPopupType(state) {
      return state.popupType
    },
    getShowPopup(state) {
      return state.showPopup
    },
    getShowPopup360(state) {
      return state.showPopup360
    },
    getSelected(state) {
      return state.selected
    },
    getSelectedIndex(state) {
      return state.selectedIndex
    },
    getSelectedLocationIndex(state) {
      return state.selectedLocationIndex
    },
    getSelectedRoute(state) {
      return state.selectedRoute;
    },
    getShipArea(state) {
      return state.shipArea;
    },
    getShipHover(state) {
      return state.shipHover;
    },
    getShipAreas(state) {
      return state.shipAreas
    },
    getObjects(state) {
      return state.objects
    },
    getLocations(state) {
      return state.locations
    }
  },
  mutations: {
    setPopupType(state, payload) {
      state.popupType = payload
    },
    setShowPopup(state, payload) {
      state.showPopup = payload
    },
    setSelected(state, payload) {
      state.selected = payload
    },
    setSelectedIndex(state, payload) {
      state.selectedIndex = payload
      state.popupType = "itemsTrade"
      state.selected = state.objects[payload]
    },
    setSelectedLocationIndex(state, payload) {
      state.selectedLocationIndex = payload
      state.popupType = "locations"
      state.selected = state.locations[payload]
    },
    setSelectedItemID(state, payload) {
      state.popupType = "items360"
      state.selected = state.items360[payload]
    },
    setSelectedRoute(state, route) {
      state.selectedRoute = route;
    },
    setShipArea(state, payload) {
      state.shipArea = payload;
      state.shipHover = null
    },
    setShipHoverArea(state, payload) {
      state.shipHoverArea = payload;
      if (!isNaN(payload)) {
        state.shipHover = state.shipAreas[payload]
      } else {
        state.shipHover = null
      }
    },
    setShipHover(state, payload) {
      state.shipHover = payload;
    }
  },
  actions: {
    nextItem({ commit, getters }) {
      let start = 1
      let index = (getters.getSelectedIndex + 1) % getters.getObjects.length
      index = Math.max(index,start)
      commit("setSelectedIndex", index)
    },
    previousItem({ commit, getters }) {
      let start = 1
      let index = (getters.getSelectedIndex - 1 + getters.getObjects.length) % getters.getObjects.length
      if (index < start) {
        index = getters.getObjects.length - 1
      }
      commit("setSelectedIndex", index)
    },
    nextLocation({ commit, getters }) {
      let index = (getters.getSelectedLocationIndex + 1) % getters.getLocations.length
      commit("setSelectedLocationIndex", index)
    },
    previousLocation({ commit, getters }) {
      let index = (getters.getSelectedLocationIndex - 1 + getters.getLocations.length) % getters.getLocations.length
      commit("setSelectedLocationIndex", index)
    }
  },
  modules: {}
})